import React from 'react';
import { createComponent } from '@lit/react';
import { IxMenu as LitComp } from '../IxMenu.js';

customElements.define('ix-menu', LitComp);

export const IxMenu = createComponent({
  tagName: 'ix-menu-react',
  elementClass: LitComp,
  react: React,
});
